export const tboData = [
    {
        id: 1,
        companyName: "ООО «Сергиево-Посадский региональный оператор»",
        measure: "Руб./м.3",
        price1: "1199,14",
        price2: "1219,12"
    }
    ]